import { HeadingDesc, SectionHeadingMed } from '../Headings';
import './articleSubSection.css';

function ArticleSubSection(props) {
  const { heading, desc } = props;
  return (
    <section className="articleSubSection">
      <SectionHeadingMed text={heading} />
      <HeadingDesc text={desc} />
    </section>
  );
}

export default ArticleSubSection;
